export default __webpack_public_path__ + "static/media/26.d78bb3aa.jpeg";